module.exports = __webpack_public_path__ + "img/3.f94f93a0.png";